module.exports = __webpack_public_path__ + "img/conf_zoom.7af1865b.png";